export default __webpack_public_path__ + "static/Open Graph Image-c8e6613cedecec3e01c3b10fcde2f2ff.jpg";